// Alma Capital ERP — الهيكل: شريط علوي + صفحات (الموقع/القسم، المستخدمون) — الدخول بحساب Google فقط
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, NavLink } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import AlmaCapitalPage from "./pages/AlmaCapitalPage";
import UsersPage from "./pages/UsersPage";

function Shell({ children }) {
  const { user, logout, isAdmin } = useAuth();
  const link = ({ isActive }) => ({ padding: "8px 14px", borderRadius: 10, textDecoration: "none", fontWeight: 800, fontSize: 13, color: isActive ? "#fff" : "#cbd5e1", background: isActive ? "rgba(255,255,255,.14)" : "transparent" });
  return (
    <div style={{ minHeight: "100vh", direction: "rtl", background: "#f8fafc" }}>
      <header style={{ background: "linear-gradient(90deg,#02100F,#0f4c4b)", color: "#fff", padding: "10px 18px", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
        <div style={{ fontWeight: 900, fontSize: 16 }}>🏛️ Alma Capital — ألما المالية</div>
        <nav style={{ display: "flex", gap: 4 }}>
          <NavLink to="/" end style={link}>موقع ألما الإلكتروني</NavLink>
          {isAdmin && <NavLink to="/users" style={link}>المستخدمون</NavLink>}
        </nav>
        <div style={{ marginInlineStart: "auto", display: "flex", alignItems: "center", gap: 10, fontSize: 12.5 }}>
          {user?.avatar_url && <img src={user.avatar_url} alt="" style={{ width: 28, height: 28, borderRadius: 999 }} />}
          <span style={{ fontWeight: 700 }}>{user?.display_name || user?.email}</span>
          <span style={{ fontSize: 10.5, background: "rgba(255,255,255,.15)", borderRadius: 999, padding: "2px 8px" }}>{user?.role === "admin" ? "أدمن" : user?.role === "manager" ? "مدير" : "مشاهد"}</span>
          <button onClick={logout} style={{ background: "rgba(255,255,255,.12)", color: "#fff", border: "none", borderRadius: 8, padding: "6px 12px", cursor: "pointer", fontFamily: "inherit", fontWeight: 700 }}>خروج</button>
        </div>
      </header>
      <main style={{ maxWidth: 1400, margin: "0 auto" }}>{children}</main>
    </div>
  );
}

function Guard({ children, admin }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <div style={{ padding: 40, textAlign: "center", color: "#94a3b8" }}>جارٍ التحميل…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && !isAdmin) return <Navigate to="/" replace />;
  return <Shell>{children}</Shell>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<Guard><AlmaCapitalPage /></Guard>} />
          <Route path="/users" element={<Guard admin><UsersPage /></Guard>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
